import React from "react";
import Box from "../Box";
import TextInput from "../TextInput";
import { color } from "@sloth-system/styled-utils";
import {
  paddingProps,
  borderRadiusProps,
  backgroundColorProps,
} from "@sloth-system/props";
import styled from "styled-components/native";

let BaseInput = styled(TextInput)`
  ${paddingProps}
  ${borderRadiusProps}
  ${backgroundColorProps}
  border: 2px solid ${color("gray.lighter")};
  text-align: right;
  font-size: 16;
  font-family: "Vazir-Bold";
`;

interface PropsType {
  bg?: string;
  p?: string;
  onChangeText?: (text: string | number) => void;
  value?: string | number;
  placeholder?: string;
  onSubmit?: () => void;
  disabled?: boolean;
  action?: React.ReactNode;
  onFocus?: () => void;
  onBlur?: () => void;
  prefix?: React.ReactNode;
  keyboardType?: string;
}

function Input(props: PropsType) {
  return (
    <Box style={{ width: "100%" }}>
      <Box style={{ position: "relative" }}>
        {props.prefix && (
          <Box style={{ position: "absolute", right: 10, top: 20 }}>
            <Box>{props.prefix}</Box>
          </Box>
        )}
        <BaseInput
          bg={props.bg}
          p={props.p}
          pr={props.prefix && "xxxl"}
          br="xm"
          onChangeText={props.onChangeText}
          value={props.value}
          placeholder={props.placeholder}
          onSubmitEditing={props.onSubmit}
          keyboardType={props.keyboardType}
          disabled={props.disabled}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
        />
        <Box style={{ position: "absolute", top: 8, left: 8 }}>
          {props.action}
        </Box>
      </Box>
    </Box>
  );
}

export default Input;
